export default "__VITE_ASSET__59OfS0QS__"